module.exports = __webpack_public_path__ + "static/media/FrameTankerDisabled.96c0dcf3.svg";